import { useVoIP } from '../hooks/useVoIP';
import { DialerModal } from './DialerModal';
import { DialerMinimized } from './DialerMinimized';
import { CallState } from '../types';

export const Dialer = () => {
  const { isDialerOpen, isDialerMinimized, callState } = useVoIP();

  if (!isDialerOpen || callState === CallState.IDLE) {
    return null;
  }

  if (isDialerMinimized) {
    return <DialerMinimized />;
  }

  return <DialerModal />;
};
